import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { ActiveToast } from 'components/layout'
import { AwardApprovalModal } from 'components/modals'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import { apiAction } from 'helpers/decorators/api'
import { connect } from 'react-redux'
import { ACTION_DISCRIMINATORS } from '../../../../constants/enums'
import { get } from 'lodash'

@modal.trigger()
@apiAction({ loadActions: true })
@connect(
  ({ api }) => ({
    actions: api.actions.list
  }),
  {}
)
class FinishAward extends Component {
  static propTypes = {
    canBeSentForSignoff: PropTypes.bool,
    onOpen: PropTypes.func,
    awardId: PropTypes.number,
    isPersonalReflectionMandatory: PropTypes.bool.isRequired,
    actions: PropTypes.object
  }

  getLastPersonalReflection = actions => {
    let alSignoffActions = actions.filter(a => get(a, 'discriminator') === ACTION_DISCRIMINATORS.awardLeaderSignoffRequest.code)

    alSignoffActions = alSignoffActions && alSignoffActions.sort((a, b) => new Date(get(b, 'createdAt')) - new Date(get(a, 'createdAt')))
    return alSignoffActions && alSignoffActions.length > 0 ? get(alSignoffActions[0], 'personalReflection') : ''
  }

  openAwardApproval = () => this.props.onOpen(MODALS.AWARD_APPROVAL, null, null)

  render() {
    const {
      canBeSentForSignoff,
      awardId,
      isPersonalReflectionMandatory,
      actions
    } = this.props

    const lastPersonalReflection = this.getLastPersonalReflection(actions)

    return (
      <div>
        <ActiveToast
          text='You can send your Award to your Award Leader for approval.'
          intlKey='label.you_can_send_award_to_leader'
          action='Send'
          actionKey='button.send'
          onClick={this.openAwardApproval}
          toShow={canBeSentForSignoff}
        />
        <AwardApprovalModal
          modalId={MODALS.AWARD_APPROVAL}
          awardId={awardId}
          isPersonalReflectionMandatory={isPersonalReflectionMandatory}
          lastPersonalReflection={lastPersonalReflection}
        />
      </div>
    )
  }
}

export default FinishAward
